import * as z from "zod/v4";

export const updateBaseShopperAgentSettings = {
  name: "updateBaseShopperAgentSettings" as const,
  input: z.object({
    enabled: z.boolean().optional(),
    iMessageConfig: z.object({ enabled: z.boolean().optional() }).optional(),
  }),
  output: z.object({ success: z.boolean() }),
};
